<template>
    <el-drawer title="合约权益" :visible.sync="drawerShow" :wrapperClosable="false" :destroy-on-close="true" size="auto"
        @close="close">
        <div class="drawer-content">
            <el-form :model="formData" :rules="rules" ref="formData" label-position="top" size="medium">
                <el-form-item prop="name" label="权益名称：">
                    <el-input v-model="formData.name" :maxlength="20" show-word-limit :disabled="disabled"></el-input>
                </el-form-item>
                <el-form-item prop="description" label="权益描述：">
                    <el-input v-model="formData.description" type="textarea" :maxlength="200" show-word-limit :disabled="disabled">
                    </el-input>
                </el-form-item>
				<el-form-item label="跳转页面：" prop="jumpParam">
					<el-input
						show-word-limit
						v-model="formData.jumpParam"
						class="input-with-select"						
						:placeholder="formData.jumpType === 1 ? '请填写演出ID' : formData.jumpType === 2 ? '请填写周边ID' : formData.jumpType === 3 ? '请填写众筹ID' : formData.jumpType === 4 ||formData.jumpType === 5 ? '请填写活动ID' : '请填写跳转链接'"
						maxlength="100" size="medium" style="display: inline-table;" >
					    <el-select
					        v-model="formData.jumpType"
					        slot="prepend"
					        placeholder="请选择"
					    >
					        <el-option :value="1" label="演出详情"></el-option>
					        <el-option :value="2" label="周边详情"></el-option>
					        <el-option :value="3" label="众筹详情"></el-option>
					        <el-option :value="4" label="分享活动"></el-option>
					        <el-option :value="5" label="膨胀优惠券"></el-option>
					        <el-option :value="6" label="其他"></el-option>
					    </el-select>					    
					</el-input>
				</el-form-item>
                <el-form-item prop="rightsType" label="权益类型：">
                    <el-select v-model="formData.rightsType" :disabled="disabled">
                        <el-option :value="1" label="实物"></el-option>
                        <el-option :value="2" label="其他"></el-option>
                    </el-select>
                    <div v-if="formData.rightsType === 1" class="color-warning">用户兑换时，需要填写收货地址</div>
                    <!-- <el-input v-model="formData.description" type="textarea" :maxlength="200" show-word-limit :disabled="disabled">
                    </el-input> -->
                </el-form-item>
                <el-form-item prop="validStartTime" label="权益生效时间：">
                    <el-date-picker v-model="formData.validStartTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
                        default-time="00:00:00"></el-date-picker>
                </el-form-item>
                <el-form-item prop="validEndTime" label="权益失效时间：">
                    <el-date-picker v-model="formData.validEndTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
                        default-time="23:59:59"></el-date-picker>
                        <small class="form-tips"><span class="el-icon-warning"></span> 权益失效时间为空，表示权益从生效时间起长期有效</small>
                </el-form-item>
                <el-form-item prop="isChecked" label="是否分配编号：">
                    <el-radio-group v-model="formData.isChecked" :disabled="disabled">
                        <el-radio :label="1">分配</el-radio>
                        <el-radio :label="0">不分配</el-radio>
                    </el-radio-group>
                </el-form-item>
                <template v-if="formData.isChecked == 1">
                    <el-form-item prop="maxNum" label="号段最大值：">
                        <el-input-number v-model="formData.maxNum" style="width:100%" :controls="false" :min="1" :max="1000" :precision="0" @change="maxNumChange" :disabled="disabled"></el-input-number>
                    </el-form-item>
                    <el-form-item prop="maxDigit" label="编号显示位数：">
                        <el-input-number v-model="formData.maxDigit" style="width:100%" :controls="false" :min="minDigit" :precision="0" :disabled="disabled"></el-input-number>
                        <small class="form-tips color-info">如设置5位，编号999乐迷端显示为00999</small>
                    </el-form-item>
                    <el-form-item prop="excludeNum" label="预留编号：">
                        <el-input v-model="formData.excludeNum" placeholder="多个编号使用“,”隔开" :disabled="disabled"></el-input>
                        <small class="form-tips color-info">预留编号不会分配给用户</small>
                    </el-form-item>
                </template>
                <!-- <el-form-item v-if="formData.id" prop="status" label="禁用状态：">
                    <el-radio-group v-model="formData.status" :disabled="disabled">
                        <el-radio :label="1">开启</el-radio>
                        <el-radio :label="0">禁用</el-radio>
                    </el-radio-group>
                </el-form-item> -->
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading">确认</el-button>
        </div>
    </el-drawer>
</template>
<script>
const defaultFormData = {
    name: "",
    description: "",
    validStartTime: "",
    validEndTime: "",
    maxNum: 0,
    maxDigit: undefined,
    excludeNum: "",
    status:1,
	jumpType:1,
    // datetimerange: [],
    isChecked: 0,
    rightsType: 1,
	jumpParam:'',
	
}
export default {
    props:{
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        const checkExcludeNum = (rule, value, callback) =>{
            let flag = true;
            if( value ){
                let _value = value.replaceAll('，',',');
                _value = _value.split(',');
                if(_value.length > 200){
                    flag = false
                }
            }
            if(!flag){
                callback(new Error('预留编号最多200个!'));
            }else{
                callback();
            }
        }

        const checkValidEndTime = (rule, value, callback) => {
            if(value && this.$utils.compareDate(this.formData.validStartTime, value) ){
                callback(new Error('权益失效时间必须大于生效时间!'));
            }else{
                callback();
            }
        }

        return {
            drawerShow: false,
            btnLoading: false,
            formData: {
                ...defaultFormData
            },
            rules: {
                name: [{ required: true, message: "请填写权益名称" }],				
                description: [{ required: true, message: "请填写权益描述" }],
                maxNum: [{ required: true, message: "请填写号段最大值"}],
                excludeNum: [{validator: checkExcludeNum}],
                validStartTime: [{ required: true, message: "请填写权益生效时间"}],
                validEndTime: [{validator: checkValidEndTime}],
            },
            minDigit: 1
        }
    },
    methods: {
        close() {
            this.formData = {
                ...defaultFormData
            }
            this.$nextTick(() => {
                this.$refs.formData && this.$refs.formData.clearValidate();
                this.btnLoading = false;
                this.drawerShow = false;
            })
        },
        show(data) {
            this.formData = {
                ...defaultFormData,
                ...data,
                // datetimerange: data ? [data.validStartTime || '', data.validEndTime || ''] : "",
                isChecked: data ? (data.maxNum == 0 ? 0 : 1) : 0,
            }
            this.drawerShow = true;
        },
        // 号段最大值
        maxNumChange(e){
            this.minDigit = e.toString().length;
            if( this.formData.maxDigit < this.minDigit ){
                this.formData.maxDigit = this.minDigit;
            }
        },
        submitForm() {
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;
                    this.$emit('onUpdate', { 
                        ...this.formData, 
                        // validStartTime: this.formData.datetimerange && this.formData.datetimerange[0],
                        // validEndTime: this.formData.datetimerange && this.formData.datetimerange[1],
                        excludeNum: this.formData.isChecked == 1 && this.formData.excludeNum ? this.formData.excludeNum.replaceAll('，',',') : "",
                        maxNum: this.formData.isChecked == 0 ? 0 : this.formData.maxNum,
                        maxDigit: this.formData.isChecked == 0 ? "" : this.formData.maxDigit,
                    });
                    this.close();
                } else {
                    return false;
                }
            });
        }
    }
}
</script>

<style lang="scss" scoped>

</style>